import m from "../../../../geodata/es2015/region/usa/utHigh";
window.am4geodata_region_usa_utHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/utHigh.js
// module id = null
// module chunks = 